<template>
  <div class="introWrap">
    <div class="intro-banner summary"></div>
    <div class="summaryConWrap">
      <div class="wrapper">
        <div class="section" id="c1">
          <div class="summaryPage">
            <div class="main">
              <div class="tibar">
                <h2>关于展会</h2>
                <i class="line"></i>
              </div>
              <div class="introduce clearfix">
                <div class="textCon">
                  <div class="ti">对美的追求是永恒的主题！</div>
                  <div class="con">
                    在智能化的大背景下，智能硬件（消费电子）、智能家居（家电及家具）、智慧交通（汽车及轨交）更频繁更深度的介入日常生活，高品质的外观效果进一步成为产品的基础要求，颜值是市场的准入门槛，严重左右消费者对产品的选择；
                  </div>
                  <div class="con">
                    同质化趋势下，消费者审美疲劳，新颖的外观效果对消费者有强大的吸引力，产品对差异化外观效果的需求拉动材料工艺色彩不断创新，材料工艺色彩本身的创新也驱动产品外观效果不断升级；
                  </div>
                  <div class="con">
                    第七届国际新材料新工艺及色彩（简称CMF）展览会暨第七届外观效果加工及应用展览会，旨在智能化的先行领域（智能硬件、智能家居、智慧交通），展现时代需求变化下，材料、工艺及色彩融合所迸发出的创新之美。
                  </div>
                </div>
                <div class="dataCon">
                  <div class="cmfTitle">
                    2023年第七届国际新材料新工艺及色彩（简称CMF）展览会暨第七届外观效果加工及应用展览会
                  </div>
                  <div class="time">日期：2023年11月15日-17日</div>
                  <div class="dataItem clearfix">
                    <ul>
                      <li>
                        <p class="num">20000m²</p>
                        <p class="text">展示面积</p>
                      </li>
                      <li>
                        <p class="num">400+</p>
                        <p class="text">展商数量</p>
                      </li>
                      <li>
                        <p class="num">30000+</p>
                        <p class="text">专业观展人数</p>
                      </li>
                      <li>
                        <p class="num">200+</p>
                        <p class="text">终端观展团</p>
                      </li>
                      <li>
                        <p class="num">8+</p>
                        <p class="text">同期论坛活动</p>
                      </li>
                      <li>
                        <p class="num">100+</p>
                        <p class="text">专业议题</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="unitDesc">
                <div class="item clearfix">
                  <span class="ti">主办单位</span>
                  <div class="con">寻材问料®</div>
                </div>
                <div class="item clearfix">
                  <div class="ti">联合主办单位</div>
                  <div class="con"><span>新材料在线®、有材®、材料馆®、测了么®</span></div>
                </div>
                <div class="item clearfix">
                  <span class="ti">支持单位</span>
                  <div class="con">
                    国家新材料产业资源共享平台、中国材料研究学会、广东省工业设计协会、广东省家用电器行业协会、浙江省工业设计协会、广东省包装技术协会、广东省増材制造协会、深圳市高分子行业协会、深圳小家电行业协会、深圳市手机行业协会、中山家用电器行业协会、佛山工业设计学会、顺德工业设计协会、珠海市工业设计协会、香港低碳设计协会。
                  </div>
                </div>
                <div class="item clearfix">
                  <span class="ti">合作大众媒体</span>
                  <div class="con">
                    光明网、南方日报、广东电视台、新华财经网、凤凰网科技、中华网广东、 中关村在线新闻频道、中国商报网、网易科技手机端（官方）、中国新闻联 播、中国日报网科技、国际在线新闻、财经界、天极网、泡泡网、科技世界网、今日头条首页、投资界、太平洋科技网、科技狗、和讯网科技。
                  </div>
                </div>
                <div class="item clearfix">
                  <span class="ti">合作行业媒体</span>
                  <div class="con">
                   新材料在线七中国涂料在线、中国化工报、中国家具网、《电器》杂志、《聚风》杂志、材料+、手机技术资讯、手机报在线、汽车材料网、盖世汽车网、千通彩、环球塑化、制造原理、微型网、旭日大数据、CMF产品视覚体验、工业设计、工业设计师、工业设计俱乐部、BiHwang工业设计、燈设 计、设计赛、苏州工业设计、设际邹工业设计、环球设计榜、日本设计小站、设计癖、普象工业设计小站、手机结构设计联盟、结构攻城狮。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="summaryPage bg2">
            <div class="main">
              <div class="cmfOtherDesc clearfix">
                <div class="item">
                  <div class="ti">
                    <i class="icon icon1"></i>
                    <h2>展会亮点</h2>
                  </div>
                  <div class="con">
                    <ul>
                      <li>
                        <span class="c1">品牌盛会</span>
                        <span class="c2">6年沉淀,已成为CMF领域极具影响力的品牌盛会,是各大终端企业保留参加的专业盛会。</span>
                      </li>
                      <li>
                        <span class="c1">对接需求</span>
                        <span class="c2">现场特设供需对接专区,一站式精准对接，高频次达成合作。</span>
                      </li>
                      <li>
                        <span class="c1">知名终端</span>
                        <span class="c2">华为、小米、美的、创维、一汽等200+终端企业现场寻方案,高效获取优质客户资源。</span>
                      </li>
                      <li>
                        <span class="c1">专业论坛</span>
                        <span class="c2">行业精英解读趋势及创新之道,把脉行业。风向,触发领先技术。</span>
                      </li>
                      <li>
                        <span class="c1">创新展会模式</span>
                        <span class="c2">开启线下展览+线上直播的展会模式,每年有5万+专业人士现场实地参观、百万观众线上观看直播和回顾视频。</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="item">
                  <div class="ti">
                    <i class="icon icon2"></i>
                    <h2>展示范围</h2>
                  </div>
                  <div class="con">
                    <ul>
                      <li>
                        <span class="c1">外观效果相关的纹理、装饰膜</span>
                        <span class="c2">模具纹理、UV转印、纳米压印、镭雕、蚀刻等纹理制备工艺；PET、PC、PVC装饰膜、透光彩膜、透明投影膜、结构色膜、彩板等装饰膜;IMD(IML IMR IMF IMT)、OMD(OML OMF)、水转印、热转印、3D印刷等装饰膜工艺。</span>
                      </li>
                      <li>
                        <span class="c1">外观效果相关的涂层、镀层、趋势研究、检测设备</span>
                        <span class="c2">涂料、油墨、反光透光涂层、颜料、色浆、染料等外观成色材料；电镀、PVD、光学度、CVD、印刷、喷涂等外观成膜工艺；色彩研究、色卡、色差仪、粗糙度、平面度、光泽度检测
等色彩趋势及外观效果检测。</span>
                      </li>
                      <li>
                        <span class="c1">外观效果相关的加工及保护辅料</span>
                        <span class="c2">抛光、喷砂、拉丝、清洗、着色等表面处理辅料；
离型膜、保护膜、保护套、耐脏污、防指纹、加硬涂层等外观
效果保护辅料。</span>
                      </li>
                      <li>
                        <span class="c1">外观效果相关的环保包装材料及其结构件、装饰件</span>
                        <span class="c2">纸、可降解、可回收塑料、金属箔等环保包装材料及其包装制品。</span>
                      </li>
                      <li>
                        <span class="c1">外观效果相关的木纹、石材、皮革、布料及其结构件、装饰件</span>
                        <span class="c2">软木、人造石、大理石、贝壳、天然皮革、再生革、人造革、无纺布、编织布等外观材料及其制备的结构件、装饰件。</span>
                      </li>
                      <li>
                        <span class="c1">外观效果相关的纤维及其复合材料、结构件、装饰件</span>
                        <span class="c2">玻璃纤维、碳纤维、芳纶等纤维及其复合材料外等外观材料及其制备的结构件、装饰件。</span>
                      </li>
                      <li>
                        <span class="c1">外观效果相关的金属材料及其结构件、装饰件</span>
                        <span class="c2">不锈钢、钛合金、铝合金、镁合金、液态金属、锌合金、金属复合材料等外观材料及其制备的结构件、装饰件；阳极氧化、钝化、微弧氧化等金属表面处理工艺。</span>
                      </li>
                       <li>
                        <span class="c1">外观效果相关的玻璃、陶瓷材料及其结构件、装饰件</span>
                        <span class="c2">玻璃、微晶玻璃、陶瓷外观材料及其制备的结构件、 装饰件；防眩光、彩色、变色、热弯、蚀刻、贴合等玻璃表处理工艺。</span>
                      </li>
                       <li>
                        <span class="c1">外观效果相关的高分子材料及其结构件、装饰件</span>
                        <span class="c2">工程塑料、特种塑料、热塑性弹性体及橡胶、免喷涂、 色母、塑胶复合材料等外观材料及其制备的结构件、装饰件。</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="section" id="c2">
          <div class="summaryPage">
            <div class="main">
              <div class="tibar">
                <h2>新常态</h2>
                <i class="line"></i>
              </div>
              <div class="N-normalCon">
                <div class="tipText">欢迎参加国际新材料新工艺及色彩展览会</div>
                <div class="conShow">
                  <p>各位尊敬的客户：</p>
                  <p style="height:20px"></p>
                  <p>国际新材料新工艺及色彩展览会（以下简称国际CMF展）的展商、观众、员工和合作伙伴的健康与安全是我们的第一要务。国际CMF展的全球安全展会策略和五点强化健康和安全计划将持续更新，但仍保留其重点：协作与参与、风险管理、规划、通讯和保障措施。</p>
                  <p style="height:20px"></p>
                  <p>目前，中国是世界范围内恢复举办展览的国家之一。国际CMF展将继续根据中国疫情的防控形势和政策，与政府防疫和公共安全部门、场馆及合作伙伴密切协作，有序举办安全合规的展会。我们将严格执行防疫政策，细致周全地部署防疫措施，包括但不限于：</p>
                   <p style="height:20px"></p>
                   <p>a) 场馆每日定期消毒，保持良好通风</p>
                   <p>b) 展商及观众需实名注册后入场，以便必要时进行追踪和联系</p>
                   <p>c) 按照展会举办城市的防疫规定，入场时检查健康码</p>
                   <p>d) 在展会入场设置非接触式体温检查</p>
                   <p>e) 在展会入场和展馆内进行口罩佩戴检查</p>
                   <p>f) 在登记柜台及展会相关功能区提供消毒液和备用口罩</p>
                   <p>g) 进行展馆人流量管理</p>
                   <p>h) 通过通讯提醒展商和观众保持社交距离，避免接触式互动</p>
                   <p>i) 通过通讯为展商和观众提供良好卫生（勤洗手、用纸巾打喷嚏、正确佩戴口罩等）建议</p>
                   <p>j) 谢绝以下人士参与展会</p>
                   <p style="height:20px"></p>
                   <p>- 新冠肺炎传播者或感染者</p>
                   <p>- 来自高风险国家/地区的人士</p>
                   <p>- 有新冠肺炎症状的人士</p>
                   <p>- 易受新冠肺炎伤害的人士</p>
                   <p style="height:20px"></p>
                   <p>在此，国际CMF展组委会诚挚邀请您重返深圳国际会展中心（宝安新馆）举办的国际CMF展览会，期待在活动现场再次见到您熟悉的身影！由于近期疫情影响，国际CMF展会举办时间延期，具体时间将另行通知，感谢您的支持！</p>
                    <p style="height:20px"></p>
                    <p>最后，呼吁大家在展会期间保持耐心和安全，尊重他人对自身安全和福祉的权利，理解和配合现场的防疫措施。祝大家在国际CMF展会上参展、参观愉快，大有所获！</p>
                  
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="section" id="c3">
          <div class="summaryPage bg2">
            <div class="main">
              <div class="tibar">
                <h2>展馆介绍</h2>
              </div>
              <div class="PavilionDesc">
                <p>
                  深圳国际会展中心（Shenzhen World Exhibition & Convention
                  Center, 英文简称Shenzhen
                  World）是深圳市政府投资建设的重大项目，由招商蛇口和华侨城联合体负责建设和运营，是集展览、会议、活动（赛事、演艺等）、餐饮、服务等于一体的超大型会展综合体。
                </p>
                <p style="height: 28px"></p>
                <p>
                  展馆一期项目于2016年9月开工建设，2019年9月全面建成，11月正式启用，将打造成为全新一代绿色展馆和智慧展馆。展馆由深圳市招华国际会展运营有限公司（招商蛇口和华侨城联合发起成立）和全球三大场馆运营机构之一的美国ASM
                  GLOBAL公司合作运营管理。
                </p>
                <p style="height: 28px"></p>
                <p>• 中文名称：深圳国际会展中心。</p>
                <p>• 英文名称：Shenzhen World Exhibition&Convention Center。</p>
                <p>• 地理位置：广东省深圳市宝安区福海街道展城路1号。</p>
                <p>• 建筑面积：160万平方米（一期）。</p>
                <p>
                  • 室内展览面积：40万平方米（一期），50万平方米（整体建成）。
                </p>
                <p>• 展厅数量：19个（一期）。</p>
                <p>• 官方网址： www.shenzhen-world.com。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="section" id="c4">
          <div class="summaryPage">
            <div class="main">
              <div class="tibar">
                <h2>展区平面图</h2>
                <i class="line"></i>
              </div>
              <div class="PavilionDesc">
                <p style="font-size: 18px">展馆主要入口</p>
                <p style="height: 12px"></p>
                <p>
                  深圳国际会展中心共有5个入口：南登录大厅、北登录大厅的东西两侧入口和位于展馆最南侧的南入口。其中两个登录大厅直接接驳两个地铁站：会展南站和会展北站。
                </p>
                <p style="height: 12px"></p>
                <p style="text-align:center"><img src="./../assets/images/map-img_01.png" alt="" /></p>
              </div>
            </div>
          </div>
        </div>
        <div class="section" id="c5">
          <div class="summaryPage">
            <div class="main">
              <div class="tibar">
                <h2>交通导航</h2>
                <i class="line"></i>
              </div>
              <div class="traffic-desc">
                <p><img src="./../assets/images/traffic_01.jpg" alt="" /></p>
                <p><img src="./../assets/images/traffic_02.jpg" alt="" /></p>
                <p><img src="./../assets/images/traffic_03.jpg" alt="" /></p>
                <p><img src="./../assets/images/traffic_04.jpg" alt="" /></p>
                <p><img src="./../assets/images/traffic_05.jpg" alt="" /></p>
                <p><img src="./../assets/images/traffic_06.jpg" alt="" /></p>
                <p><img src="./../assets/images/traffic_07.jpg" alt="" /></p>
                <p><img src="./../assets/images/traffic_08.jpg" alt="" /></p>
                <p><img src="./../assets/images/traffic_09.jpg" alt="" /></p>
              </div>
            </div>
          </div>
        </div>
        <div class="section" id="c6">
          <div class="summaryPage">
            <div class="main">
              <div class="tibar">
                <h2>酒店住宿</h2>
                <i class="line"></i>
              </div>
              <div class="flat-desc">
                <p style="text-align: center">
                  <img src="./../assets/images/Hotel_01_a.jpg" alt="" />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="section" id="c7">
          <div class="summaryPage bg2">
            <div class="main">
              <div class="tibar">
                <h2>合作伙伴</h2>
                <i class="line"></i>
              </div>
              <div class="partner-desc">
                  <partner />
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav class="fixedNav">
        <a :class="['nav1',selected_index==0?'current':'']" href="#c1"><span>关于展会</span></a>
        <!-- <a :class="['nav1',selected_index==1?'current':'']" href="#c2"><span>新常态</span></a> -->
        <a :class="['nav1',selected_index==1?'current':'']" href="#c3"><span>展馆介绍</span></a>
        <a :class="['nav1',selected_index==2?'current':'']" href="#c4"><span>展区平面图</span></a>
        <a :class="['nav1',selected_index==3?'current':'']" href="#c5"><span>导航交通</span></a>
        <a :class="['nav1',selected_index==4?'current':'']" href="#c6"><span>酒店住宿</span></a>
        <a :class="['nav1',selected_index==5?'current':'']" href="#c7"><span>合作伙伴</span></a>
      </nav>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import partner from "../components/partner.vue";
export default {
  data() {
    return {
      scroll: "",
      selected_index: 0,
    };
  },
  components: {
    partner
  },
  methods: {
    dataScroll: function () {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    loadSroll: function () {
      var self = this;
      var sections = document.getElementsByClassName("section");
      for (var i = sections.length - 1; i >= 0; i--) {
        if (self.scroll >= sections[i].offsetTop - 120) {
          self.selected_index = i;
          break;
        }
      }
    },
  },
  watch: {
    scroll: function () {
      this.loadSroll();
    },
  },
  mounted() {
    window.addEventListener("scroll", this.dataScroll);
    $(document).scroll(documentscroll);

    function documentscroll() {
      var oScrolltop = $(document).scrollTop();
      if (oScrolltop > 280) {
        $(".fixedNav").addClass("active");
      } else {
        $(".fixedNav").removeClass("active");
      }
    }
  },
};
</script>

<style>
</style>